(function () {
  var ATTR_ACCEPTED = 'US Tariff Acknowledgment';
  var ATTR_VERSION = 'Acknowledgment Version';
  var ATTR_ACCEPTED_AT = 'Accepted At (UTC)';
  var ATTR_CART_TOKEN = 'Cart Token';
  var CHECKOUT_SELECTOR = [
    'button[name="checkout"]',
    'input[name="checkout"]',
    '#checkout',
    'a[href="/checkout"]',
    'a[href^="/checkout?"]'
  ].join(',');
  var EXPRESS_SELECTOR = [
    '.shopify-payment-button',
    '.additional-checkout-buttons',
    '.cart__dynamic-checkout-buttons',
    '[data-shopify="payment-button"]'
  ].join(',');
  var DEPRECATED_IMPORT_FEES_CSS_SELECTOR = 'link[href*="us-import-fees-popup.css"]';
  var DEPRECATED_IMPORT_FEES_SECTION_SELECTOR = [
    '#shopify-section-sections--28791467802950__us_import_fees_popup',
    '.section-ok-us-import-popup',
    '[data-ok-us-import-popup]'
  ].join(',');

  function removeDeprecatedImportFeesStyles() {
    Array.prototype.slice.call(document.querySelectorAll(DEPRECATED_IMPORT_FEES_CSS_SELECTOR)).forEach(function (link) {
      link.parentNode.removeChild(link);
    });
  }

  function removeDeprecatedImportFeesPopup() {
    document.body && document.body.classList.remove('ok-us-import-popup-open');
    Array.prototype.slice.call(document.querySelectorAll(DEPRECATED_IMPORT_FEES_SECTION_SELECTOR)).forEach(function (element) {
      var section = element.closest && element.closest('.section-ok-us-import-popup');
      (section || element).remove();
    });
  }

  function getPanels() {
    return Array.prototype.slice.call(document.querySelectorAll('[data-us-tariff-ack]'));
  }

  function normalizePanelCountry(panel) {
    var shopifyCountry = window.Shopify && window.Shopify.country;
    if (panel.dataset.country === 'US' || shopifyCountry === 'US') {
      panel.dataset.enabled = 'true';
    }
  }

  function isPanelVisible(panel) {
    return Boolean(panel && panel.getClientRects && panel.getClientRects().length);
  }

  function getActivePanel() {
    return getPanels().find(function (panel) {
      normalizePanelCountry(panel);
      return panel.dataset.enabled === 'true' && isPanelVisible(panel);
    }) || null;
  }

  function getCheckbox(panel) {
    return panel && panel.querySelector('[data-us-tariff-ack-checkbox]');
  }

  function getError(panel) {
    return panel && panel.querySelector('[data-us-tariff-ack-error]');
  }

  function shouldGate() {
    return Boolean(getActivePanel());
  }

  function isAccepted() {
    var panel = getActivePanel();
    var checkbox = getCheckbox(panel);
    return !panel || Boolean(checkbox && checkbox.checked);
  }

  function setError(visible) {
    var error = getError(getActivePanel());
    if (error) error.hidden = !visible;
  }

  function setCheckoutDisabled(disabled) {
    Array.prototype.slice.call(document.querySelectorAll(CHECKOUT_SELECTOR)).forEach(function (button) {
      if (disabled) {
        button.setAttribute('aria-disabled', 'true');
        button.setAttribute('data-us-tariff-disabled', 'true');
        if ('disabled' in button) button.disabled = true;
      } else {
        button.removeAttribute('aria-disabled');
        button.removeAttribute('data-us-tariff-disabled');
        if ('disabled' in button) button.disabled = false;
      }
    });

    Array.prototype.slice.call(document.querySelectorAll(EXPRESS_SELECTOR)).forEach(function (container) {
      container.classList.toggle('us-tariff-ack-blocked', disabled);
      container.setAttribute('aria-disabled', disabled ? 'true' : 'false');
      container.querySelectorAll('button, input, a').forEach(function (node) {
        if (disabled) {
          node.setAttribute('tabindex', '-1');
          node.setAttribute('aria-disabled', 'true');
          if ('disabled' in node) node.disabled = true;
        } else {
          node.removeAttribute('tabindex');
          node.removeAttribute('aria-disabled');
          if ('disabled' in node) node.disabled = false;
        }
      });
    });
  }

  async function getCart() {
    var response = await fetch('/cart.js', { credentials: 'same-origin' });
    if (!response.ok) throw new Error('Unable to read cart');
    return response.json();
  }

  async function updateCartAttributes(attributes) {
    var response = await fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: attributes })
    });
    if (!response.ok) throw new Error('Unable to update cart attributes');
    return response.json();
  }

  function postServerLog(panel, payload) {
    var url = panel && panel.dataset.logUrl;
    if (!url) return;
    try {
      var params = new URLSearchParams();
      Object.keys(payload).forEach(function (key) {
        params.set(key, payload[key] || '');
      });
      params.set('_', String(Date.now()));
      var pixel = new Image();
      pixel.referrerPolicy = 'no-referrer-when-downgrade';
      pixel.src = url + (url.indexOf('?') === -1 ? '?' : '&') + params.toString();
    } catch (error) {}
  }

  async function persistAcceptance(panel) {
    var cart = await getCart();
    var acceptedAt = new Date().toISOString();
    var version = panel.dataset.version || 'US-TARIFF-v8-2026-08';
    var token = cart.token || '';

    await updateCartAttributes({
      [ATTR_ACCEPTED]: 'Accepted',
      [ATTR_VERSION]: version,
      [ATTR_ACCEPTED_AT]: acceptedAt,
      [ATTR_CART_TOKEN]: token
    });

    postServerLog(panel, {
      event: 'tariff_ack',
      cart_token: token,
      version: version,
      client_accepted_at: acceptedAt,
      user_agent: window.navigator.userAgent,
      page: window.location.pathname
    });
  }

  async function clearAcceptance() {
    await updateCartAttributes({
      [ATTR_ACCEPTED]: '',
      [ATTR_VERSION]: '',
      [ATTR_ACCEPTED_AT]: '',
      [ATTR_CART_TOKEN]: ''
    });
  }

  async function syncInitialState(panel) {
    try {
      var cart = await getCart();
      var checkbox = getCheckbox(panel);
      if (!checkbox || !cart.attributes) return;
      checkbox.checked = false;
      if (cart.attributes[ATTR_ACCEPTED] === 'Accepted') await clearAcceptance();
    } catch (error) {}
  }

  function refreshGate() {
    setCheckoutDisabled(shouldGate() && !isAccepted());
    if (isAccepted()) setError(false);
  }

  function bindPanel(panel) {
    if (!panel || panel.dataset.usTariffBound === 'true') return;
    panel.dataset.usTariffBound = 'true';

    var checkbox = getCheckbox(panel);
    if (!checkbox) return;

    syncInitialState(panel).finally(refreshGate);

    checkbox.addEventListener('change', function () {
      setCheckoutDisabled(true);
      setError(false);
      if (checkbox.checked) {
        persistAcceptance(panel).then(refreshGate).catch(function () {
          checkbox.checked = false;
          setError(true);
          refreshGate();
        });
      } else {
        clearAcceptance().finally(refreshGate);
      }
    });
  }

  function bindAll() {
    removeDeprecatedImportFeesStyles();
    removeDeprecatedImportFeesPopup();
    getPanels().forEach(function (panel) {
      normalizePanelCountry(panel);
      bindPanel(panel);
    });
    refreshGate();
  }

  removeDeprecatedImportFeesStyles();
  removeDeprecatedImportFeesPopup();

  document.addEventListener('click', function (event) {
    if (!shouldGate() || isAccepted()) return;
    var target = event.target.closest(CHECKOUT_SELECTOR + ',' + EXPRESS_SELECTOR);
    if (!target) return;
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    setError(true);
    var panel = getActivePanel();
    if (panel) panel.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }, true);

  document.addEventListener('submit', function (event) {
    if (!shouldGate() || isAccepted()) return;
    var submitter = event.submitter;
    if (submitter && submitter.matches && submitter.matches('[name="checkout"]')) {
      event.preventDefault();
      setError(true);
    }
  }, true);

  document.addEventListener('DOMContentLoaded', bindAll);
  document.addEventListener('shopify:section:load', bindAll);
  document.addEventListener('cart:updated', bindAll);

  var observer = new MutationObserver(function () {
    window.clearTimeout(observer._timer);
    observer._timer = window.setTimeout(bindAll, 100);
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
